/* tslint:disable */
/* eslint-disable */
export enum ActionGrouping {
  Origin = 'ORIGIN',
  Status = 'STATUS',
  Type = 'TYPE',
  Tag = 'TAG',
  None = 'NONE',
}
